import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CWSMSAPIService {

	public static URLPrefix: string = "https://api.cwsms.com";

	private messageSource = new BehaviorSubject('default message');
	currentMessage = this.messageSource.asObservable();

	constructor(private http: Http) { }

	changeMessage(message: any) {
		this.messageSource.next(message);
	}

	getPhoneNumberCountryCode(phoneNumber) {
        var /** @type {?} */ phoneUtil = PhoneNumberUtil.getInstance();
        var /** @type {?} */ pnf = PhoneNumberFormat;
        try {
            var /** @type {?} */ number = phoneUtil.parse(phoneNumber, '');
            return phoneUtil.getRegionCodeForNumber(number);
        }
        catch (e) {
            console.log(e);
            return null;
        }
	}

	setCookie(cname, cvalue, expireMinutes) {
		var d = new Date();
		d.setTime(d.getTime() + (expireMinutes*60*1000));
		var expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	post(urlPath, parameters, callback) {
		let opt: RequestOptions;
		let headers: Headers = new Headers;

		headers.set('Content-type', 'application/json');

		opt = new RequestOptions({
			headers: headers,
			withCredentials: true
		});

		this.http.post(CWSMSAPIService.URLPrefix+urlPath, parameters, opt)
		.subscribe(data => {
			callback(null, data.json());
		}, error => {
			callback(error.json());
		});
	}

	get(urlPath, callback) {
		let opt: RequestOptions;
		let headers: Headers = new Headers;

		headers.set('Content-type', 'application/json');

		opt = new RequestOptions({
			headers: headers,
			withCredentials: true
		});

		this.http.get(CWSMSAPIService.URLPrefix+urlPath, opt)
		.subscribe(data => {
			callback(null, data.json());
		}, error => {
			callback(error.json());
		});
	}

	delete(urlPath, callback) {
		let opt: RequestOptions;
		let headers: Headers = new Headers;

		headers.set('Content-type', 'application/json');

		opt = new RequestOptions({
			headers: headers,
			withCredentials: true
		});

		this.http.delete(CWSMSAPIService.URLPrefix+urlPath, opt)
		.subscribe(data => {
			callback(null, data.json());
		}, error => {
			callback(error.json());
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/cwsmsapi.service.ts